import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Box, IconButton } from '@mui/material';
import { spacing } from 'common/theme';
import { TextHot } from 'components/common/TextHot';
import { ChipHot } from 'components/common/ChipHot';
import { IconHot } from 'components/common/IconHot';
import EditIconSvg from 'assets/personal_zone/Edit_outline.svg';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { PersonalInfoForm } from 'components/common/PersonalInfoForm/PersonalInfoForm';
import { generateTestId } from 'app/functions';
import { useTranslations } from 'common/hooks/useTranslations';

const PersonalInfoDetails = ({ testID, isMobileView }) => {
  const history = useHistory();
  const userData = useSelector((store) => store.config.UserData);
  const { translate } = useTranslations();
  const [isEditing, setIsEditing] = useState(false);
  const [formKey, setFormKey] = useState(0);

  const handleBack = () => {
    history.goBack();
  };

  const toggleEditing = () => {
    if (isEditing) {
      setFormKey(formKey + 1);
    }
    setIsEditing(!isEditing);
  };

  const handleUpdateSuccess = () => {
    setIsEditing(false);
  };

  return (
    <Box 
      sx={{ 
        width: '100%', 
        mb: isMobileView ? 0 : 6,
      }}
    >
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          mb: 4
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: `${spacing.xs}px` }}>
          {isMobileView && (
            <IconButton 
              onClick={handleBack}
              sx={{ p: 0, ml: 1 }}
              testID={generateTestId(testID, 'back-btn')}
            >
              <ChevronRight sx={{ fontSize: spacing.xxxl }} />
            </IconButton>
          )}
          <TextHot size={isMobileView ? 'xxl' : 'xxxl'} bold='bold'>
            {translate('personal_zone_details')}
          </TextHot>
        </Box>

        <ChipHot
          testID={generateTestId(testID, 'chip-edit')}
          icon={<IconHot src={EditIconSvg} size={spacing.xl} />}
          label={isEditing ? translate('are_you_sure_modal_cancel_button_label') : translate('personal_info_details_chip_label_edit')}
          onClick={toggleEditing}
        />
      </Box>

      <PersonalInfoForm 
        testID={generateTestId(testID, 'form')} 
        userData={userData} 
        disabled={!isEditing}
        isEditing={isEditing}
        onSuccess={handleUpdateSuccess}
        key={formKey}
      />
    </Box>
  );
};

export default PersonalInfoDetails;